import InstaceAxios  from "./Api";

export const getRifa = async (id_rifa = false) => {
    const result = await InstaceAxios.get(`rifa/rifa?id_rifa=${id_rifa}`)
        .then(res => res)
        .catch(error => error)
    return result
}

export const eliminarRifa = async (id_rifa) => {
    const result = await InstaceAxios.delete(`rifa/eliminar?id_rifa=${id_rifa}`)
        .then(res => res)
        .catch(error => error)
    return result
}

export const getRifasDisponibles = async () => {
    const result = await InstaceAxios.get('rifa/disponibles')
        .then(res => res)
        .catch(error => error)
    return result
}

export const validarNumeroRifa = async (id_rifa, numero) => {
    const result = await InstaceAxios.get(`rifa/validar/numero?id_rifa=${id_rifa}&numero=${numero}`)
        .then(res => res)
        .catch(error => error)
    return result
}
